<div class="flex flex-row flex-wrap w-1/3">
  <div *ngIf="showAllButton" (click)="clearFilter($event)" class="flex flex-row items-center item btn-font-rounded mb-16">
    <mat-icon *ngIf="selectedCount === 0" name="done" class="icons mr-6"></mat-icon>
    {{ 'CATALOGUE.FILTER.ALL' | transloco: {totalCount: totalCount} | uppercase }}
  </div>

  <div (click)="toggleSelected(filterItem, $event)"
       *ngFor="let filterItem of filterItems"
       [ngClass]="{'selected': filterItem.selected}"
       class="flex items-center item btn-font-rounded mb-16">
    <div>{{ filterItem.label | uppercase }}</div>
  </div>

  <div (click)="clearFilter($event)" *ngIf="showClearButton" [ngClass]="{'disabled': selectedCount === 0}"
       class="flex flex-row items-center item btn-font-rounded mb-16">
       <mat-icon svgIcon="refresh" class="icons mr-6"></mat-icon>
    {{ 'CATALOGUE.FILTER.CLEAR_FILTERS' | transloco | uppercase }}
  </div>
</div>
